import {Fieldset, TextInput} from '@mantine/core'
import {ProjectSelect} from '../../../calendar/components/ProjectSelect.tsx'
import {NoProjectWarning} from '../../components/NoProjectWarning.tsx'
import type {FormValues} from './FormValues.ts'
import type {UseFormReturnType} from '@mantine/form'

type Props = {
  form: UseFormReturnType<FormValues>
  disabled: boolean
}

export const FormFields = ({form, disabled: containerDisabled}: Props) => {
  const disabled = containerDisabled

  return (
    <>
      <Fieldset legend={'General'}>
        <TextInput
          label={'Name'}
          key={form.key('name')}
          {...form.getInputProps('name')}
          style={{minWidth: 325}}
          required
          disabled={disabled}
        />
        <ProjectSelect
          key={form.key('projectId')}
          {...form.getInputProps('projectId')}
          value={form.values.projectId}
          onChange={(projectId) => form.setFieldValue('projectId', projectId)}
          disabled={disabled}
        />
        {!form.values.projectId && <NoProjectWarning />}
      </Fieldset>
      <Fieldset legend={'Calendar'}>
        <TextInput
          label={'Calendar URL'}
          description={'.ics format'}
          placeholder={'https://...'}
          key={form.key('url')}
          {...form.getInputProps('url')}
          style={{minWidth: 325}}
          required
          disabled={disabled}
        />
      </Fieldset>
    </>
  )
}
